import React, { useEffect, useState, Fragment } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
import { TOTAL_CUPOS } from '../data/content';
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function UrgencyBar() {
  // countdown starting from a fixed target for this session (approx 3h)
  const [remaining, setRemaining] = useState(3 * 3600 + 24 * 60 + 51);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(r => r > 0 ? r - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(remaining / 3600);
  const m = Math.floor(remaining % 3600 / 60);
  const s = remaining % 60;
  const cuposRestantes = TOTAL_CUPOS;
  const cuposTotal = 1500;
  const pct = Math.round(cuposRestantes / cuposTotal * 100);
  return <div className="rounded-xl border border-[#F5C518]/40 bg-black/60 p-4" data-id="element-257" data-mp="2f75zdl1sw74r">
      <div className="flex items-center justify-center gap-2 text-[#F5C518]" data-id="element-258" data-mp="2f98pe52ye09h">
        <ClockIcon className="h-4 w-4" data-id="element-259" data-mp="2b6m30jp1x7jo" />
        <span className="font-oswald text-xs font-700 uppercase tracking-wide" data-id="element-260" data-mp="1rxkj6u5yvwqg">
          La oferta termina en
        </span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-261" data-mp="1wostdsf4fm4o">
        {[{
        v: h,
        l: 'Horas'
      }, {
        v: m,
        l: 'Min'
      }, {
        v: s,
        l: 'Seg'
      }].map((t, i) => <Fragment key={t.l} data-id="element-262" data-mp="2aobq7p2hfb1o" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-263" data-mp="2alzbdks0tgsu">
              <span className="min-w-[52px] rounded-lg bg-[#F5C518] px-2 py-1.5 text-center font-anton text-2xl text-black tabular-nums" data-id="element-264" data-mp="2flkb3xf0lt6m">
                {pad(t.v)}
              </span>
              <span className="mt-1 text-[10px] uppercase tracking-wide text-neutral-400" data-id="element-265" data-mp="25nxpyt74h5e7">
                {t.l}
              </span>
            </div>
            {i < 2 && <span className="pb-4 font-anton text-2xl text-[#F5C518]" data-id="element-266" data-mp="u9ajwmxkfn31">:</span>}
          </Fragment>)}
      </div>

      <div className="mt-4" data-id="element-267" data-mp="2wuwbjlb30vrd">
        <div className="mb-1.5 flex items-center justify-between text-[12px]" data-id="element-268" data-mp="2wyaccp43kwwp">
          <span className="flex items-center gap-1.5 text-neutral-300" data-id="element-269" data-mp="2rxmnoa3ccs5n">
            <UsersIcon className="h-3.5 w-3.5 text-[#F5C518]" data-id="element-270" data-mp="2n5mlsc3pnp6f" /> Plazas restantes
          </span>
          <span className="font-700 text-[#F5C518]" data-id="element-271" data-mp="2i834127t0u9q">
            {cuposRestantes} plazas
          </span>
        </div>
        <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/10" data-id="element-272" data-mp="2e6hk4wwurfq1">
          <div className="h-full rounded-full bg-[#F5C518]" style={{
          width: `${pct}%`
        }} data-id="element-273" data-mp="296db1ry9xn9u" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-neutral-400" data-id="element-274" data-mp="1z8guulqhc24v">
          Últimas plazas a este precio — se agotan rápido
        </p>
        <p className="mt-2 text-center font-oswald text-xs font-700 uppercase tracking-[0.14em] text-[#F5C518]" data-id="element-275" data-mp="2f43b6zchtzt">
          Exclusivo lanzamiento
        </p>
      </div>
    </div>;
}